import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton, FlexColumn, FlexRow } from "@similarweb/ui-components";

export const StyledDownloadExtensionBannerContainer = styled(FlexRow)`
    border-radius: 6px;
    background: ${colorsPalettes.blue[100]};
    padding: 14px 32px 6px 32px;
    justify-content: space-between;
    position: relative;
`;

export const StyledDownloadExtensionImage = styled.img`
    height: 181px;
`;

export const StyledDownloadExtensionTitle = styled(FlexRow)`
    gap: 8px;
    align-items: center;
    margin-bottom: 4px;
`;

export const StyledDownloadExtensionLink = styled.a`
    margin-top: 24px;
`;

export const StyledDownloadExtensionContent = styled(FlexColumn)`
    justify-content: center;
`;

export const StyledCloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;
